export default {
  full_menu: 'Pełne menu',
  free: 'GRATIS',
};
